/** Enumération des fréquences */
export enum FrequenceAutorisee {
    JOUR = 1,
    SEMAINE = 2,
    MOIS = 3,
    ANNEE = 4
}